import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import AboutUsGif from "../../../Assets/AboutUsGif.gif";

const OurCompany = () => {
    const [gifSrc, setGifSrc] = useState(AboutUsGif);

    useEffect(() => {
        const interval = setInterval(() => {
            setGifSrc(`${AboutUsGif}?t=${new Date().getTime()}`); // Add a unique timestamp
        }, 5000); // Reload GIF every 3 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    return (
        <>
            <Typography
                sx={{
                    fontWeight: "700",
                    fontSize: "50px",
                    lineHeight: "75px",
                    color: "#474747",
                    textAlign: "center",
                }}
            >
                About US
            </Typography>

            <Box
                sx={{
                    background: "#E5EDFF",
                    padding: "30px",
                    borderRadius: "25px",
                    marginTop: "20px",
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            <Box>
                                <Typography
                                    sx={{
                                        fontSize: "30px",
                                        fontWeight: "600",
                                        marginBottom: "20px",
                                        color: "#474747",
                                        lineHeight: "35px",
                                    }}
                                >
                                    Our Company
                                </Typography>
                            </Box>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec
                                ultricies lorem. Proin quis magna ut eros varius dignissim. Sed sit
                                amet dui varius, commodo turpis ac, auctor lorem. Vestibulum
                                faucibus ex non risus cursus, non sollicitudin odio malesuada.
                                Suspendisse potenti. Integer at arcu non orci convallis varius at at
                                ligula. In scelerisque justo nec facilisis pharetra. Cras varius
                                augue eget turpis gravida, ut scelerisque libero elementum.
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6}>
                        <img
                            src={gifSrc}
                            alt="about"
                            style={{ width: "100%", height: "100%" }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <Typography>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec
                            ultricies lorem. Proin quis magna ut eros varius dignissim. Sed sit
                            amet dui varius, commodo turpis ac, auctor lorem. Vestibulum faucibus
                            ex non risus cursus, non sollicitudin odio malesuada. Suspendisse
                            potenti. Integer at arcu non orci convallis varius at at ligula. In
                            scelerisque justo nec facilisis pharetra. Cras varius augue eget turpis
                            gravida, ut scelerisque libero elementum.
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default OurCompany;
